import { Component, Input, OnInit } from '@angular/core';
import { ApiPattern } from 'src/app/models_new/classes/api-models/ApiPattern';
import { IApiRobotConfiguration } from 'src/app/models_new/classes/api-models/ApiRobotConfiguration';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss'],
})
export class StepThreeComponent implements OnInit {
  @Input() patternConfig: ApiPattern;
  @Input() robotConfigs: IApiRobotConfiguration[];

  displayedRobotConfig: IApiRobotConfiguration;

  ngOnInit() {
    this.displayedRobotConfig = this.robotConfigs[0];
  }
}
